import NavBarWizardBaseCtrl from 'edge/platform/widgets/wizard/NavBarWizardBaseCtrl';

const fn = function ($scope, $element) {
    const baseNavbarCtrl = new NavBarWizardBaseCtrl($scope, $element);
    const ctrl = Object.create(baseNavbarCtrl);


    return ctrl.create($scope);
};

fn.$inject = ['$scope', '$element'];

export default fn;
